module.exports = __webpack_public_path__ + "static/media/social-vk.268c234d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/social-vk.svg
// module id = 325
// module chunks = 0